/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmployeeDto } from '../../models/employee-dto';

export interface EmployeeControllerFindOne$Params {
  id: number;
}

export function employeeControllerFindOne(http: HttpClient, rootUrl: string, params: EmployeeControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<EmployeeDto>> {
  const rb = new RequestBuilder(rootUrl, employeeControllerFindOne.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EmployeeDto>;
    })
  );
}

employeeControllerFindOne.PATH = '/api/employee/{id}';
